<template>
  <div class="container-fluid">
    <div class="row">
      <sidebar></sidebar>
      <nav-header></nav-header>

      <!-- MAIN CONTENT start -->
      <main role="main" class="col-12 col-sm-9 col-md-10 ml-sm-auto body">
        <sidebar-sm></sidebar-sm>
       

                <div class="page">

  

  <!-- ============ CONTACT CARD ============ -->
  <div class="surface p-4 p-md-4">
    <h1 class="page-title">ჩემი მომსახურების მენეჯერი</h1>
    <div class="row no-gutters">

      <!-- left: person + actions -->
      <div class="col-lg-7 pr-lg-4">
        <div class="person-flex d-flex align-items-start">
          <img class="avatar flex-shrink-0"
               :src="'data:image/jpeg;base64,'+firstFriend[0].img"
               :alt="firstFriend[0].person">
          <div>
            <div class="contact-name">{{ firstFriend[0].person }}</div>
            <div class="contact-role mb-3 text-muted">{{ firstFriend[0].full_position }}</div>
            <p class="contact-desc mb-0 text-muted">
             მე ვიქნები თქვენი მომსახურების მენეჯერი პირველი სემესტრის განმავლობაში. 
                სასწავლო პროცესთან და ადმინისტრაციულ საკითხებთან დაკავშირებული კითხვების შემთხვევაში შეგიძლიათ მომმართოთ.
            </p>
          </div>
        </div>

        <div class="d-flex flex-wrap mt-4">
          <a :href="'mailto:'+firstFriend[0].email_ug" class="btn-red mr-3 mb-2">
            <i class="bi bi-envelope"></i> მიწერა
          </a>
          <a href="tel:0322552222" class="btn-red-outline mb-2">
            <i class="bi bi-telephone"></i> დარეკვა
          </a>
        </div>
      </div>

      <!-- divider -->
      <div class="col-auto d-none d-lg-flex px-3">
        <div class="vline"></div>
      </div>

      <!-- right: quick info -->
      <div class="col-lg pl-lg-2 mt-4 mt-lg-0 d-flex align-items-center">
        <div class="w-100">
          <div class="info-row"><i class="bi bi-envelope"></i> {{ firstFriend[0].email_ug }}</div>
          <div class="info-row"><i class="bi bi-telephone"></i> 0322552222</div>
          <div class="info-row"><i class="bi bi-clock"></i> ორშაბათი - პარასკევი,&nbsp; 10:00 - 18:00</div>
        </div>
      </div>

    </div>
  </div>

  <!-- ============ TOPICS ============ -->

  <div class="surface p-4">
      <h2 class="section-title">რა საკითხებზე შემიძლია მოგმართოთ?</h2>
    <div class="row">




      <div style="cursor: pointer;" @click="openSentMessage(service.serviceID,service.title)" class="col-12 col-sm-6 col-lg mb-4 mb-lg-0" v-if="services.length>0" v-for="service of services">
        <div class="topic">
          <div class="topic-icon"><span v-html="service.icon"></span></div>
          <div class="topic-title">{{ service.title }}</div>
          <div class="topic-text">{{ service.description }}</div>
        </div>
      </div>

       

    </div>
  </div>

  <!-- ============ RECENT COMMUNICATION ============ -->
 
  <div class="surface p-4">
 <h2 class="section-title">ბოლო კომუნიკაცია</h2>
    
 
 <div class="comm-row position-relative" style="cursor: pointer;" @click="openConversationModal(lastCommunication.conversationID,lastCommunication.statusID)" v-if="lastCommunications.length>0" v-for="lastCommunication of lastCommunications"> 

            <div class="comm-icon"><i class="bi bi-envelope"></i></div>
            <div class="flex-grow-1">
                <div class="comm-title">{{ lastCommunication.title }}</div>
                <div class="comm-sub">{{ lastCommunication.message }}</div>
            </div>
            <div class="comm-date mr-4 d-none d-md-block">{{ lastCommunication.put_date }}</div>
            <span class="badge-soft" :class="lastCommunication.statusID==1?'badge-blue':'badge-green'">{{ lastCommunication.status_name }}</span>

            <div class="unread" v-if="lastCommunication.countNew>0">{{ lastCommunication.countNew }}</div>
    </div>
 

    <div class="text-center mt-3">
      <a href="#" @click="showAllCommunications(showRows)" class="view-all">{{!showRows?'ყველა კომუნიკაციის ნახვა':'დამალვა'}}  <i :class="!showRows?'bi-chevron-right':'bi-chevron-left'" class="bi"></i></a>
    </div>

  </div>

</div>


<conversation-messages :serviceID="chosenServiceID" :serviceTitle="chosenServiceTitle"></conversation-messages>
<conversation-chat :conversationID="chosenConversationID" :currentStatusID="currentStatusID" @read-event="getCommunicationRow"></conversation-chat>




      </main>
      <!-- MAIN CONTENT end -->
    </div>
  </div>
</template>

<script>
  import sidebar from '../components/navbar/sidebar';
  import sidebarSm from '../components/navbar/sidebar-sm';
 
  import NavHeader from '../components/navbar/nav-header';
 
 import firstFriendResource from '../api/firstFriendResource';
 import conversationMessages from '../components/student-first-friend/conversation-messages.vue';
import ConversationMessages from '../components/student-first-friend/conversation-messages.vue';
import conversationChat from '../components/student-first-friend/conversation-chat.vue';
import ConversationChat from '../components/student-first-friend/conversation-chat.vue';

const firstFriendResourceObj=new firstFriendResource()

  

  export default {
    name: 'first-friend',
    components: {   NavHeader, sidebar, sidebarSm,conversationMessages,conversationChat },

    data() {
      return {
         firstFriend:[],
         services:[],
         chosenServiceID:0,
         chosenServiceTitle:null,
         lastCommunications:[],
         chosenConversationID:0,
         currentStatusID:0,
         showRows:false
      }
    },
 

    mounted() {
        firstFriendResourceObj.getFirstFriend().then(response=>{

      this.firstFriend=response.data


    })

    firstFriendResourceObj.getServices().then(response=>{
        this.services=response.data
    })

    
    this.getLastCommunications(0,0)

      

    
     
    },

    methods: {

            getLastCommunications(param,all){

                       firstFriendResourceObj.getLastCommunications(param,all).then(response=>{

                        if(param==0){

                            this.lastCommunications=response.data
                        }else {

                                

                               const index = this.lastCommunications.findIndex(item => item.conversationID === param);

                                if (index !== -1) {
                                    this.lastCommunications.splice(index, 1, response.data[0]);
                                }


                        }
        })
                
            }
        
        ,

        openSentMessage(serviceID,title){
            this.chosenServiceID=serviceID
            this.chosenServiceTitle=title
             this.$bvModal.show('first-friend-conversation-modal'); 
        },


        openConversationModal(conversationID,statusID){
                this.chosenConversationID=conversationID
                this.currentStatusID=statusID
                this.$bvModal.show('first-friend-conversation-chat-modal'); 
        },

        getCommunicationRow(payload){
            
                this.getLastCommunications(payload,0)

        },
        showAllCommunications(){

            this.showRows=!this.showRows
            if(this.showRows){
                this.getLastCommunications(0,1)
            }else {
                    this.getLastCommunications(0,0)
            }

              

        }
   
    }
  };
</script>

<style scoped>
  :root {
      --red: #e11d1d;
      --ink: #1f2937;
      --muted: #6b7280;
      --line: #6b7280;
      --card-border: #6b7280;
    }


    .page { max-width: 1200px; margin: 0 auto; }

    .page-title {
      font-weight: 700;
      font-size: 1.5rem;
      margin-bottom: 20px;
    }

    .section-title {
      font-weight: 700;
      font-size: 1.15rem;
      margin: 28px 0 16px;
    }

    .surface {
      background: #fff;
      border: 1px solid var(--card-border);
      border-radius: 18px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, .03);
      margin-bottom: 10px;
    }

    /* ---------- contact card ---------- */
    .avatar {
      width: 112px; height: 112px;
      border-radius: 50%; object-fit: cover;
    }
    .contact-name { font-weight: 700; font-size: 1.35rem; }
    .contact-role { color: var(--muted); font-size: .95rem; }
    .contact-desc {
      color: var(--muted); font-size: .9rem;
      line-height: 1.55; max-width: 520px;
    }

    .btn-red {
      background: var(--red); border: 1px solid var(--red);
      color: #fff; border-radius: 10px; padding: 11px 26px;
      font-weight: 600; display: inline-flex; align-items: center;
    }
    .btn-red:hover { background: #c81717; color: #fff; }
    .btn-red-outline {
      background: #fff; border: 1px solid var(--red);
      color: var(--red); border-radius: 10px; padding: 11px 26px;
      font-weight: 600; display: inline-flex; align-items: center;
    }
    .btn-red-outline:hover { background: #fdecec; color: var(--red); }
    .btn-red i, .btn-red-outline i { margin-right: 10px; }

    .info-row { display: flex; align-items: center; color: var(--ink); font-size: .95rem; }
    .info-row + .info-row { margin-top: 18px; }
    .info-row i { color: #9ca3af; font-size: 1.15rem; margin-right: 12px; }

    .vline { width: 1px; background: #b8b9bd; align-self: stretch; }

    /* ---------- topic cards ---------- */
    .topic {
      border: 1px solid #b3b4b6;
      border-radius: 16px;
      padding: 26px 18px;
      text-align: center;
      height: 100%;
    }
    .topic-icon {
      width: 64px; height: 64px; border-radius: 50%;
      background: #fdecec; color: var(--red);
      display: inline-flex; align-items: center; justify-content: center;
      font-size: 1.6rem; margin-bottom: 14px;
    }
    .topic-title { font-weight: 700; font-size: .98rem; margin-bottom: 8px; }
    .topic-text { color: var(--muted); font-size: .82rem; line-height: 1.5; }

    /* ---------- communication list ---------- */
    .comm-row {
      display: flex; align-items: center;
      padding: 18px 4px;
      border: 1px solid #eeeef0;
      margin-bottom: 5px;
      border-radius: 14px;
    }
    .comm-icon {
      width: 44px; height: 44px; flex: 0 0 44px;
      border-radius: 10px; background: #f4f5f7; color: #6b7280;
      display: inline-flex; align-items: center; justify-content: center;
      font-size: 1.15rem; margin-right: 16px;
    }
    .comm-title { font-weight: 600; font-size: .92rem; }
    .comm-sub { color: var(--muted); font-size: .82rem; }
    .comm-date { color: var(--muted); font-size: .85rem; white-space: nowrap; }

    .badge-soft {
      border-radius: 999px; padding: 6px 14px;
      font-size: .78rem; font-weight: 600; white-space: nowrap;
    }
    .badge-green { background: #e7f6ec; color: #1a9d54; }
    .badge-blue  { background: #e6f0fd; color: #2f6fed; }

    .view-all {
      color: var(--red); font-weight: 600; text-decoration: none;
      display: inline-flex; align-items: center;
    }
    .view-all i { margin-left: 8px; }
    .view-all:hover { color: #c81717; text-decoration: none; }

    .unread{
        background-color: #c81717;
        color: white;
        width: 20px;
        height: 20px;
        border-radius: 10px;
        text-align: center;
         animation: pulse 1.5s ease-in-out infinite;
         position: absolute;
         right: -8px;
             top: -10px;
    }

@keyframes pulse {
    0% {
      transform: scale(0.9);
      box-shadow: 0 0 0 0 rgba(233, 69, 96, 0.7);
    }
    70% {
      transform: scale(1);
      box-shadow: 0 0 0 25px rgba(233, 69, 96, 0);
    }
    100% {
      transform: scale(0.9);
      box-shadow: 0 0 0 0 rgba(233, 69, 96, 0);
    }
  }


    /* spacing helpers (BS4 has no gap utilities) */
    .person-flex > * + * { margin-left: 1.75rem; }
    @media (max-width: 767.98px) {
      .person-flex { flex-direction: column; align-items: flex-start; }
      .person-flex > * + * { margin-left: 0; margin-top: 1rem; }
    }
</style>
